module.exports = __webpack_public_path__ + "img/V4.46e845f6.png";